import React, {useContext, useEffect, useState} from 'react';

import {ActivityIndicator, Platform, View} from 'react-native';
import {AppCtx} from './partnerWeb/configs/appContext';
import PartnerSignUpLogin from './partnerWeb/partnerSignUpLogin';
import {
  getLocalData,
  LocalStorageType,
} from './partnerWeb/configs/localStorage';
import {getUserContext, navigationRef} from './partnerWeb/configs/util';
import ThemeProvider, {THEMES} from '@voltmoney/theme';
import {ROUTE_PARTNER} from './partnerWeb/configs/types';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import {
  getPathFromState,
  NavigationContainer,
  PathConfigMap,
} from '@react-navigation/native';
import _ from 'lodash';
import FaqPage from './partnerWeb/pages/Faq/Faq';
import partnerDashBoard from './partnerWeb/partnerDashBoard';
import partnerDashboardNew from './partnerWeb/PartnerDashboardNew';
import {init, setUserId} from '@amplitude/analytics-react-native';
import {BUILD_TYPE, getBuildType} from '@voltmoney/micro-frontend';
import AffiliateSignupPage from './affiliateWeb/AffiliateSignupPage';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {initializeApp} from 'firebase/app';
import remoteConfig from '@react-native-firebase/remote-config';
import {fetchAndActivate, getRemoteConfig} from "firebase/remote-config";

const Stack = createNativeStackNavigator();

const WebPartnersApp: React.FunctionComponent = () => {
  const [isLoading, setLoading] = useState(true);
  const [emailIsPresent, setEmailIsPresent] = useState(false);
  const AppContext = useContext(AppCtx);
  ThemeProvider.init(THEMES.LIGHT_MOBILE);

  const setStore = async () => {
    const isLoggedIn = await getLocalData(LocalStorageType.ACCESS_TOKEN);

    if (isLoggedIn) {
      const context = await getUserContext();
      if (_.get(context, 'linkedPartnerAccounts.accountHolderEmail', false)) {
        setEmailIsPresent(true);
      } else {
        setEmailIsPresent(false);
      }
    }
    setLoading(false);
  };


  useEffect(() => {
    initializeAmplitudeForPartner();
    setStore();
  }, []);

  const initializeAmplitudeForPartner = (userId = '') => {
    const buildType = getBuildType();
    const partnerAmplitudeKey =
      buildType === BUILD_TYPE.PARTNER_STAGING
        ? 'c7ee428e33f4fcd0493c0e4daa328db7'
        : 'edc0ae0b093ae59882b52329a70cac70';

    userId === '' ? init(partnerAmplitudeKey) : setUserId(userId);
  };

  const initializeFirebase = async () => {
    if(Platform.OS === 'web'){
        const firebaseConfig = {
            apiKey: "AIzaSyCqsCPKr9UpZF-VeNS9hX4OXp3oF5DAhik",
            authDomain: "volt-web-app.firebaseapp.com",
            projectId: "volt-web-app",
            storageBucket: "volt-web-app.appspot.com",
            messagingSenderId: "200598813164",
            appId: "1:200598813164:web:adc6c7ddfb7bdad0c0a8c9",
            measurementId: "G-WSGQFFRFN3"
        };
        const app = await initializeApp(firebaseConfig)
        const remoteConfig = await getRemoteConfig(app);

        remoteConfig.settings.minimumFetchIntervalMillis = 10000;
        try {
            await fetchAndActivate(remoteConfig);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            if (remoteConfig?._storageCache?.activeConfig) {
              //@ts-ignore
              const allConfigs = remoteConfig?._storageCache?.activeConfig;
              const outputObject = {};

              for (const [key, value] of Object.entries(allConfigs)) {
                  //@ts-ignore
                outputObject[key] = value;
              }
              const  stringifiedValue = JSON.stringify(outputObject)
              await AsyncStorage.setItem("remoteConfig",stringifiedValue)
            }
        } catch (error) {
            // Handle any errors that occur during fetching and activation
            console.error("Error fetching and activating remote config:", error);
        }
    }
}

  initializeFirebase();


    const config: {
        initialRouteName?: string | number | undefined;
        screens: PathConfigMap<any>;
    } = {
        screens: {
            initialRouteName: ROUTE_PARTNER.SIGNUP,
            path: `${ROUTE_PARTNER.PARTNER}`,
            [ROUTE_PARTNER.DASHBOARD]: {
                path: `${ROUTE_PARTNER.PARTNER}/${ROUTE_PARTNER.DASHBOARD}/:params?`,
                exact: true,
            },
            [ROUTE_PARTNER.SIGNUP]: {
                path: `${ROUTE_PARTNER.PARTNER}/${ROUTE_PARTNER.SIGNUP}/:params?`,
                exact: true,
            },
            [ROUTE_PARTNER.FAQ]: {
                path: `${ROUTE_PARTNER.PARTNER}/${ROUTE_PARTNER.FAQ}/:params?`,
                exact: true,
            },
            [ROUTE_PARTNER.DASHBOARD_NEW]: {
                path: `${ROUTE_PARTNER.PARTNER}/${ROUTE_PARTNER.DASHBOARD_NEW}/:params?`,
                exact: true,
            },
            [ROUTE_PARTNER.LEADS]: {
                path: `${ROUTE_PARTNER.PARTNER}/${ROUTE_PARTNER.LEADS}/:params?`,
                exact: true,
            },
            [ROUTE_PARTNER.ACTIVE_CUSTOMER]: {
                path: `${ROUTE_PARTNER.PARTNER}/${ROUTE_PARTNER.ACTIVE_CUSTOMER}/:params?`,
                exact: true,
            },
            [ROUTE_PARTNER.REFERRED_PARTNER]: {
                path: `${ROUTE_PARTNER.PARTNER}/${ROUTE_PARTNER.REFERRED_PARTNER}/:params?`,
                exact: true,
            },
            [ROUTE_PARTNER.COLLATERAL]: {
                path: `${ROUTE_PARTNER.PARTNER}/${ROUTE_PARTNER.COLLATERAL}/:params?`,
                exact: true,
            },
            [ROUTE_PARTNER.DEMO_VIDEOS]: {
                path: `${ROUTE_PARTNER.PARTNER}/${ROUTE_PARTNER.DEMO_VIDEOS}/:params?`,
                exact: true,
            },
            [ROUTE_PARTNER.MY_ACCOUNT]: {
                path: `${ROUTE_PARTNER.PARTNER}/${ROUTE_PARTNER.MY_ACCOUNT}/:params?`,
                exact: true,
            },
            [ROUTE_PARTNER.CHECK_LIMIT]: {
                path: `${ROUTE_PARTNER.PARTNER}/${ROUTE_PARTNER.CHECK_LIMIT}/:params?`,
                exact: true,
            },
            [ROUTE_PARTNER.AFFILIATE_SIGNUP]: {
                path: `${ROUTE_PARTNER.PARTNER}/${ROUTE_PARTNER.AFFILIATE_SIGNUP}/:params?`,
                exact: true,
            },
            [ROUTE_PARTNER.EARNING]: {
                path: `${ROUTE_PARTNER.PARTNER}/${ROUTE_PARTNER.EARNING}/:params?`,
                exact: true,
            },
            [ROUTE_PARTNER.AUTH]: {
                path: `${ROUTE_PARTNER.PARTNER}/${ROUTE_PARTNER.AUTH}/:params?`,
                exact: true,
            },
            [ROUTE_PARTNER.VIEW_CUSTOMER_PORTFOLIO]: {
                path: `${ROUTE_PARTNER.PARTNER}/${ROUTE_PARTNER.VIEW_CUSTOMER_PORTFOLIO}/:params?`,
                exact: true,
            },
            [ROUTE_PARTNER.CAPITAL_GAIN]: {
                path: `${ROUTE_PARTNER.PARTNER}/${ROUTE_PARTNER.CAPITAL_GAIN}/:params?`,
                exact: true,
            },
            [ROUTE_PARTNER.INTEREST_CALCULATOR]: {
                path: `${ROUTE_PARTNER.PARTNER}/${ROUTE_PARTNER.INTEREST_CALCULATOR}/:params?`,
                exact: true,
            },
        },
    };

    return (
        <AppCtx.Provider value={AppContext}>
            <NavigationContainer
                ref={navigationRef}
                documentTitle={{
                    enabled: false,
                }}
                linking={{
                    prefixes: [
                        'https://app.voltmoney.in',
                        'https://app.staging.voltmoney.in',
                        'voltmoney://',
                        'http://localhost:3000',
                    ],
                    config,
                    getPathFromState: (state, options) => {
                        /*** Manually extracted params adding back in URL ***/
                        return `${getPathFromState(state, options)}${
                            window.location.href.includes('?')
                                ? `?${window.location.href.split('?')[1]}`
                                : ''
                        }`;
                    },
                }}>
                <Stack.Navigator
                    initialRouteName={
                        emailIsPresent ? ROUTE_PARTNER.DASHBOARD : ROUTE_PARTNER.SIGNUP
                    }>
                    <Stack.Screen
                        name={ROUTE_PARTNER.DASHBOARD}
                        component={partnerDashBoard}
                        options={{title: 'Volt Partners | Dashboard'}}
                    />
                    <Stack.Screen
                        name={ROUTE_PARTNER.DASHBOARD_NEW}
                        component={partnerDashboardNew}
                        options={{
                            title: 'Volt Partners | Dashboard',
                            props: {route: ROUTE_PARTNER.DASHBOARD_NEW},
                        }}
                    />
                    <Stack.Screen
                        name={ROUTE_PARTNER.SIGNUP}
                        component={PartnerSignUpLogin}
                        options={{
                            title: 'Volt Partners | Login or Empanel',
                            props: {route: ROUTE_PARTNER.SIGNUP},
                        }}
                    />
                    <Stack.Screen
                        name={ROUTE_PARTNER.FAQ}
                        component={FaqPage}
                        options={{title: 'Volt Partners | Login or Empanel'}}
                    />
                    <Stack.Screen
                        name={ROUTE_PARTNER.LEADS}
                        component={partnerDashboardNew}
                        options={{
                            title: 'Volt Partners | Dashboard',
                            props: {route: ROUTE_PARTNER.LEADS},
                        }}
                    />
                    <Stack.Screen
                        name={ROUTE_PARTNER.ACTIVE_CUSTOMER}
                        component={partnerDashboardNew}
                        options={{
                            title: 'Volt Partners | Dashboard',
                            props: {route: ROUTE_PARTNER.ACTIVE_CUSTOMER},
                        }}
                    />
                    <Stack.Screen
                        name={ROUTE_PARTNER.REFERRED_PARTNER}
                        component={partnerDashboardNew}
                        options={{
                            title: 'Volt Partners | Dashboard',
                            props: {route: ROUTE_PARTNER.REFERRED_PARTNER},
                        }}
                    />
                    <Stack.Screen
                        name={ROUTE_PARTNER.COLLATERAL}
                        component={partnerDashboardNew}
                        options={{
                            title: 'Volt Partners | Dashboard',
                            props: {route: ROUTE_PARTNER.COLLATERAL},
                        }}
                    />
                    <Stack.Screen
                        name={ROUTE_PARTNER.DEMO_VIDEOS}
                        component={partnerDashboardNew}
                        options={{
                            title: 'Volt Partners | Dashboard',
                            props: {route: ROUTE_PARTNER.DEMO_VIDEOS},
                        }}
                    />
                    <Stack.Screen
                        name={ROUTE_PARTNER.MY_ACCOUNT}
                        component={partnerDashboardNew}
                        options={{
                            title: 'Volt Partners | Dashboard',
                            props: {route: ROUTE_PARTNER.MY_ACCOUNT},
                        }}
                    />
                    <Stack.Screen
                        name={ROUTE_PARTNER.CHECK_LIMIT}
                        component={partnerDashboardNew}
                        options={{
                            title: 'Volt Partners | Dashboard',
                            props: {route: ROUTE_PARTNER.CHECK_LIMIT},
                        }}
                    />
                    <Stack.Screen
                        name={`${ROUTE_PARTNER.AFFILIATE_SIGNUP}`}
                        component={AffiliateSignupPage}
                        options={{
                            title: 'Volt Partners | Dashboard',
                            props: {route: ROUTE_PARTNER.AFFILIATE_SIGNUP},
                        }}
                    />
                    <Stack.Screen
                        name={ROUTE_PARTNER.EARNING}
                        component={partnerDashboardNew}
                        options={{
                            title: 'Volt Partners | Dashboard',
                            props: {route: ROUTE_PARTNER.EARNING},
                        }}
                    />
                    <Stack.Screen
                        name={ROUTE_PARTNER.AUTH}
                        component={partnerDashboardNew}
                        options={{
                            title: 'Volt Partners | Dashboard',
                            props: {route: ROUTE_PARTNER.AUTH},
                        }}
                    />
                    <Stack.Screen
                        name={ROUTE_PARTNER.VIEW_CUSTOMER_PORTFOLIO}
                        component={partnerDashboardNew}
                        options={{
                            title: 'Volt Partners | Dashboard',
                            props: {route: ROUTE_PARTNER.VIEW_CUSTOMER_PORTFOLIO},
                        }}
                    />
                    <Stack.Screen
                        name={ROUTE_PARTNER.CAPITAL_GAIN}
                        component={partnerDashboardNew}
                        options={{
                            title: 'Volt Partners | Dashboard',
                            props: {route: ROUTE_PARTNER.CAPITAL_GAIN},
                        }}
                    />
                    <Stack.Screen
                        name={ROUTE_PARTNER.INTEREST_CALCULATOR}
                        component={partnerDashboardNew}
                        options={{
                            title: 'Volt Partners | Dashboard',
                            //@ts-ignore
                            props: {route: ROUTE_PARTNER.INTEREST_CALCULATOR},
                        }}
                    />
                </Stack.Navigator>
            </NavigationContainer>
        </AppCtx.Provider>
    );
};
export default WebPartnersApp;
